
import { defineComponent } from "vue";

export class DeleteAPFormData {
  mac?: string;
  deleteConfirm?: string;

  constructor(attrs = {}) {
    Object.assign(this, attrs);
  }
}

export default defineComponent({
  name: "DeleteAPForm",
  props: {
    form: {
      type: DeleteAPFormData,
      required: true,
    },
  },
  methods: {
    onChangeForm(v = {}) {
      this.$emit("change", new DeleteAPFormData({ ...this.form, ...v }));
    },
  },
  components: {},
});
